<template>
  <div 
    ref="item"
    class="timeline-item"
    :style="{marginBottom:bottomMargin+'px'}"
  >
    <div ref="title" class="title">
      <h3>{{ title }}</h3></div>
    <div class="circle-line-container">
      <div class="circle"></div>
      <div class="line"></div>
      <div class="line short"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineItem',
  mounted(){
    //position title
    setTimeout(
      ()=>{
        this.styleTitle()
      },
      100
    )
    window.addEventListener('resize',this.styleTitle)
    
  },
  unmounted(){
    window.removeEventListener('resize',this.styleTitle)
  },

  props: {
    title: {
      type: String,
      required: true
    },
    numBlocks: {
      type: Number,
      required: true
    },
    blockHeight: {
      type: Number,
      required: true
    },
    index:{
      type: Number,
      required: true
    }
  },
  computed:{
    bottomMargin(){
       //adjust margin to align with grid
      if(this.index>0){
        return this.numBlocks*this.blockHeight-20
      }
      else{
        return this.numBlocks*this.blockHeight-10
      }
    }
  },
  methods:{
    styleTitle(){
      this.$refs.title.style = "top: -"+(this.$refs.title.clientHeight+20)+"px"
    },


  }
}
</script>

<style scoped>
.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 0;
  transform:translate(0px,0px)
}

.title {

  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0rem 1rem;
  color:white;
  background-image:url('../assets/art/event_label01.png');
  background-size: 100% 100%;
  position:absolute;
  border: 10px solid transparent;
  border-image: url('../assets/art/event_label02.png') 16 round;
}

.circle-line-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.circle {
  width: 20px;
  height: 20px;
  background-color: lightgray;
  border-radius: 50%;
  z-index: 2;
  outline: 2px solid lightgray;
  outline-offset:5px
}

.line {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  width: 53vw;
  height: 2px;
  background-color: rgba(0,0,0,0.5);
  z-index: 1;
  opacity: 0.5;
}

.line.short{
  width:12.5vw;
  background-color: rgba(255,255,255,0.7);
}

</style>
